import React, { Component } from 'react';

import type {
    Presenter,
    PresentedView,
    PresentedData,
    Nullable,
} from './Presentation';

type Props = {
    presenter: Presenter,
    presentedComponent: any,
};

type State = {
    presentedProps?: any
};

export class Presented extends Component<Props, State> implements PresentedView {
    state: {presentedProps: PresentedData};
    
    private presenter: Nullable<Presenter>;
    private presentedComponentRef: Nullable<Component<Props, State>>;
    // indicates whether we already called viewWillUpdate() on the presenter
    private presenterRegistered: boolean;

    constructor(options: {presenter: Presenter, presentedComponent: Object}) {
        super(options);

        // console.log('PRESENTED: Presented.constructor()');
        this.presenterRegistered = false;

        this.state = {
            presentedProps: options.presenter.presentedData()
        };

        this.UNSAFE_componentWillReceiveProps(this.props);
    }

    getPresentedComponent(): Nullable<Component<Props, State>> {
        return this.presentedComponentRef;
    }

    render(): React.ReactNode {
        // console.log(`PRESENTED: Presented.render(presentedComponent: ${this.props.presentedComponent.constructor.name}, props: ${JSON.stringify(this.state.presentedProps)}})`);

        return (
            <this.props.presentedComponent
                {...this.state.presentedProps}
                ref={(c: Component<Props, State>) => { this.presentedComponentRef = c; }} />
        );
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        // console.log(`PRESENTED: Presented.componentDidUpdate()`); // prevProps: ${JSON.stringify(prevProps)}, this.props: ${JSON.stringify(this.props)})`);
        if (this.props.presenter !== prevProps.presenter) {
            if (this.presenterRegistered) {
                // unregister old presenter and register new one
                prevProps.presenter.viewWillNotUpdate(this);
                this.props.presenter.viewWillUpdate(this);
            }
            // load data from new presenter
            this.setState({
                presentedProps: this.props.presenter.presentedData()
            });
        }
    }

    UNSAFE_componentWillReceiveProps(props: {presenter: Presenter, presentedComponent: Object}) {
        // console.log(`PRESENTED: Presented.UNSAFE_componentWillReceiveProps()`);
        // console.log(`PRESENTED: - props.presenter: ${props.presenter.constructor.name}`);
        // console.log(`PRESENTED: - props.presentedComponent: ${props.presentedComponent.constructor.name}`);
        if (props.presenter !== this.props.presenter) {
            if (this.presenterRegistered) {
                // unregister old presenter and register new one
                this.props.presenter.viewWillNotUpdate(this);
                props.presenter.viewWillUpdate(this);
            }
            // load data from new presenter
            this.setState({
                presentedProps: props.presenter.presentedData()
            });
        }
    }

    componentDidMount() {
        this.props.presenter.viewWillUpdate(this);
        this.presenterRegistered = true;
    }

    componentWillUnmount() {
        this.props.presenter.viewWillNotUpdate(this);
        this.presenterRegistered = false;
    }

    updatePresentedData(data: PresentedData) {
        this.setState({
            presentedProps: data
        });
    }
}

